export type ExampleQuestion = { text: string; value: string }

/**
 * Session type is a dynamic string identifier that corresponds to a route.id from the config.
 * Common values include: "open", "translate", "rag", "video-insight", "ai-parser"
 * With modularization, variants can have custom IDs like "explorer-legal", "explorer-hr", etc.
 */
export type SessionType = string

/**
 * Known session type IDs for the default module routes.
 * These are reference constants only - the system is fully dynamic and supports any route ID.
 * With modularization, route IDs can be any unique string (e.g., "explorer-legal", "explorer-hr").
 */
export const KNOWN_SESSION_TYPES = {
  Explorer: "open",
  Translator: "translate",
  DocumentInsight: "localDocs",
  Navigator: "rag",
  VideoInsight: "video-insight",
  AIParser: "ai-parser",
  TenderChat: "tender-chat",
  None: "none",
} as const

/**
 * Validates if a session type is one of the known types.
 * Note: With dynamic routes, this is informational only - variants may have custom IDs.
 */
export function isKnownSessionType(sessionType: string): boolean {
  return (Object.values(KNOWN_SESSION_TYPES) as string[]).includes(sessionType)
}
